import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostSummaryFetchFailedAction = {
	type: 'AI_COST_SUMMARY_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostSummaryFetchFailedAction => ({
	type: 'AI_COST_SUMMARY_FETCH_FAILED',
	payload,
});
